import type React from 'react';

import { ProgressBar } from '@change/ds-core-ui/ProgressBar';
import { Text } from '@change/ds-core-ui/Text';

import { useContributionCount } from './hooks/useContributionCount';

export const ContributionCount: React.FC<EmptyProps> = () => {
	const {
		data: {
			localizedCount,
			localizedGoal,
			completionPercentage,
			countLabel,
			countA11yLabel,
			goalLabel,
			goalA11yLabel,
			thermometerAriaLabel,
		},
	} = useContributionCount();

	return (
		<>
			<div className="w-full" data-qa="contributions-thermometer">
				<ProgressBar ariaLabel={thermometerAriaLabel} percentage={completionPercentage} />
			</div>

			<div className="w-full">
				<div className="sr-only">
					<Text>{countA11yLabel}</Text>
					<Text>{goalA11yLabel}</Text>
				</div>
				<div className="grid grid-cols-2 grid-rows-2" aria-hidden>
					<Text fontWeight="bold" className="text-typography-information -mb-2 font-bold" size="large">
						{localizedCount}
					</Text>

					<Text fontWeight="bold" size="large" className="text-typography-weak -mb-2 text-right font-bold">
						{localizedGoal}
					</Text>

					<Text className="text-typography-information font-semibold" size="x-small">
						{countLabel}
					</Text>

					<Text className="text-typography-weak text-right font-semibold" size="x-small">
						{goalLabel}
					</Text>
				</div>
			</div>
		</>
	);
};
